/* Playeras Viudas · ajustes propios del tema (copia WO2026 staging) */
(function () {
  /* "Ordenar por": nombres claros y solo las opciones útiles.
     Si la colección usa otro orden de entrada, ese también se muestra. */
  var NOMBRES = {
    'manual': 'Recomendados',
    'best-selling': 'Más vendidos',
    'title-ascending': 'Nombre: A a la Z',
    'title-descending': 'Nombre: Z a la A',
    'price-ascending': 'Precio: menor a mayor',
    'price-descending': 'Precio: mayor a menor',
    'created-ascending': 'Más antiguos',
    'created-descending': 'Más nuevos'
  };
  var MOSTRAR = ['best-selling', 'created-descending', 'price-ascending', 'price-descending'];

  function ordenActual() {
    var param = new URLSearchParams(window.location.search).get('sort_by');
    return param || window.viudasOrden || '';
  }

  function ajustarOrden(select) {
    if (select.getAttribute('data-viudas') === '1') return;
    var actual = ordenActual() || select.value;
    var porValor = {};
    Array.prototype.forEach.call(select.options, function (opcion) {
      porValor[opcion.value] = opcion;
    });
    var lista = MOSTRAR.slice();
    if (actual && lista.indexOf(actual) === -1 && porValor[actual]) lista.unshift(actual);
    select.setAttribute('data-viudas', '1');
    while (select.firstChild) select.removeChild(select.firstChild);
    lista.forEach(function (valor) {
      var opcion = porValor[valor];
      if (!opcion) return;
      opcion.textContent = NOMBRES[valor] || opcion.textContent;
      opcion.selected = valor === actual;
      select.appendChild(opcion);
    });
  }

  /* Filtros en celular: el botón de abajo dice cuántos resultados hay ("Ver 12 resultados").
     El número sale del conteo del panel, que el tema actualiza con cada filtro. */
  function textoResultados() {
    var conteo = document.querySelector('#FacetFiltersFormMobile .mobile-facets__count');
    var numero = conteo ? (conteo.textContent.match(/\d+/) || [])[0] : null;
    if (numero === null || numero === undefined) return 'Ver resultados';
    numero = parseInt(numero, 10);
    if (numero === 0) return 'Sin resultados';
    if (numero === 1) return 'Ver 1 resultado';
    return 'Ver ' + numero + ' resultados';
  }

  function ajustarBotonesResultados() {
    var texto = textoResultados();
    document.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__footer .popup-modal__toggle__close .btn__texts > span').forEach(function (etiqueta) {
      if (etiqueta.textContent !== texto) etiqueta.textContent = texto;
    });
  }

  /* Carrusel de reseñas de la portada: flechas y puntos que avanzan de 4 en 4 */
  function carruseles() {
    document.querySelectorAll('[data-viudas-carrusel]:not([data-listo])').forEach(function (carrusel) {
      carrusel.setAttribute('data-listo', '1');
      var pista = carrusel.querySelector('.viudas-carrusel__pista');
      var anterior = carrusel.querySelector('.viudas-carrusel__flecha--prev');
      var siguiente = carrusel.querySelector('.viudas-carrusel__flecha--next');
      var puntos = carrusel.querySelectorAll('.viudas-carrusel__punto');
      if (!pista || !anterior || !siguiente) return;
      var total = pista.children.length;
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function actual() {
        return pista.clientWidth ? Math.round(pista.scrollLeft / pista.clientWidth) : 0;
      }
      function ir(indice) {
        indice = Math.max(0, Math.min(total - 1, indice));
        pista.scrollTo({ left: indice * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
      }
      function estado() {
        var indice = actual();
        anterior.disabled = indice <= 0;
        siguiente.disabled = indice >= total - 1;
        puntos.forEach(function (punto, i) {
          punto.setAttribute('aria-current', i === indice ? 'true' : 'false');
        });
      }

      anterior.addEventListener('click', function () { ir(actual() - 1); });
      siguiente.addEventListener('click', function () { ir(actual() + 1); });
      puntos.forEach(function (punto, i) {
        punto.addEventListener('click', function () { ir(i); });
      });
      pista.addEventListener('scroll', function () { window.requestAnimationFrame(estado); }, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  function aplicar() {
    document.querySelectorAll('select[name="sort_by"]').forEach(ajustarOrden);
    ajustarBotonesResultados();
    carruseles();
  }

  /* Botón flotante de WhatsApp: solo en el inicio y en las categorías
     (la ficha de producto ya tiene su botón "Pídela por WhatsApp") */
  function botonFlotante() {
    var ruta = window.location.pathname;
    var enInicio = ruta === '/' || ruta === '';
    var enCategoria = ruta.indexOf('/collections') === 0 && ruta.indexOf('/products/') === -1;
    if (!(enInicio || enCategoria) || document.querySelector('.viudas-wa-flotante')) return;
    var boton = document.createElement('a');
    boton.className = 'viudas-wa-flotante';
    boton.href = 'https://wa.me/528126676286?text=' + encodeURIComponent('¡Hola, Viudas! 🖤 Tengo una duda.');
    boton.target = '_blank';
    boton.rel = 'noopener';
    boton.setAttribute('aria-label', 'Escríbenos por WhatsApp');
    boton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="#ffffff"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35m-5.42 7.4h-.01a9.87 9.87 0 0 1-5.030-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.890-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.88 9.88m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89a11.82 11.82 0 0 0-3.48-8.41z"/></svg>';
    document.body.appendChild(boton);
  }

  botonFlotante();
  aplicar();
  /* Los filtros recargan la sección sin recargar la página: se vuelve a aplicar */
  new MutationObserver(aplicar).observe(document.body, { childList: true, subtree: true });
})();
